import type { WeightRepository } from "../ports/repositories";
import { addCalendarDays, type CalendarDate } from "../../domain/shared/calendar-date";
import { buildWeightChartSeries, type WeightChartPoint } from "../../domain/weight/rolling-average";

export async function getWeightChart(
  weights: WeightRepository,
  start: CalendarDate,
  end: CalendarDate,
): Promise<readonly WeightChartPoint[]> {
  const entries = await weights.listBetween(addCalendarDays(start, -4), end);
  return buildWeightChartSeries(entries, start, end);
}
